<template>
  <div class="cookies-modal" v-if="showModal" >
    <div class="cookies-modal-content">
      <div class="cookies-modal-content-text">
        <div style="display: inline;">{{ $t("We use cookies to make our website work better and improve your experience. By continuing to use the site,you agree to our ") }}</div>
        <div style="display: inline; color: #3B8EFF; text-decoration: underline; cursor: pointer;" @click="onClickPrivacy">{{ $t("Privacy Policy")}}</div>
      </div>
      <div class="cookies-modal-button-list">
        <div class="cookies-modal-button" style="background-color: var(--main-color);" @click="onClickAccept">{{ $t("Accept")}}</div>
        <div class="cookies-modal-button" @click="onClickRefuse">{{ $t("Decline")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { globalConfig } from '../../util/globalStore'
import config from '../../api/config'
import { getLanguage, openUrl } from '../../util'
import { buildPortalHomeUrl } from '../../util/portuguesePalPortalNavigation'
export default {
  name: "cookies",
  created() {},
  data() {
    return {
      showModal: false
    };
  },
  props: {
    
  },
  emits: ["selected"],
  methods: {
    onClickAccept() {
      let config = globalConfig()
      config.accessCookies = true
      this.showModal = false
      this.$emit("selected", true)
    },

    onClickRefuse(){
      let config = globalConfig()
      config.accessCookies = false
      this.showModal = false
      this.$emit("selected", false)
    },

    onClickPrivacy() {
      openUrl(buildPortalHomeUrl(config.home, '/privacy', getLanguage(), this.$route.query, globalConfig().ref))
    }
  },
  mounted() {
    let config = globalConfig()
    if (config.accessCookies == null) {
      this.showModal = true
    } else {
      this.showModal = false
    }
  }
};
</script>

<style lang="scss" scoped>
.cookies-modal{
  position: fixed;
  left: 0;
  bottom: 0.1rem;
  width: 100vw;
  z-index: 10;
}
.cookies-modal-content{
  position: absolute;
  right: 5%;
  bottom: 0.3rem;
  width: 90%;
  max-width: 5.0rem;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(65,65,65,0.29);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.17rem 0.3rem 0.17rem 0.3rem;
}
.cookies-modal-content-text{
  font-weight: 500;
  font-size: 0.16rem;
  color: #000000;
}
.cookies-modal-button-list{
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-around;
  margin-top: 0.1rem;
  width: 100%;
}
.cookies-modal-button{
  margin: 0.1rem;
  color: #000000;
  font-size: 0.16rem;
  width: 40%;
  padding: 0.1rem;
  background: #E7E7E7;
  border-radius: 9px;
  cursor: pointer;
  text-align: center;
}
</style>
